import { InputsContext } from '@context/calculator/inputs-context';
import { useContext } from 'react';

export const useInputs = () => {
    const context = useContext(InputsContext);

    if (!context) throw new Error('useInputs must be used within InputsProvider');

    return context;
};
